import Select from 'react-select'
import SelectedOptions from './SelectedOptions'
import { getAutosuggestStyle } from '../dive-guides/utils'
import { FormattedMessage } from 'react-intl'
import { parseQuery } from 'utils'
import filter from 'lodash/filter'
import { useEffect, useRef, useState } from 'react'
import { OPERATOR_TYPES } from './helpers'
import { convertToArray } from '../../utils'
import store from 'store2'
import PropTypes from 'prop-types'

export default function DealsFilters({
  type,
  monthes,
  selectedMonthes,
  setSelectedMonthes,
  setDealsType,
  setSelectedCountries,
  selectedCountries,
  removeSelectedMonth,
  removeSelectedCountry,
}) {
  const typeRef = useRef()
  const timeRef = useRef()
  const countryRef = useRef()
  const [isMenuOpen, setIsMenuOpen] = useState({})

  const openMenu = (type) =>
    setIsMenuOpen({
      [type]: true,
    })
  const onInputChange = (type, action) => {
    if(action === 'menu-close') {
      setIsMenuOpen({
        [type]: false,
      })
    }
  }

  useEffect(() => {
    const { country, date } = parseQuery()
    if(country) {
      const countries = filter(window.info.activeCountryList, (item) =>
        convertToArray(country).includes(`${item.id}`),
      )
      setSelectedCountries(countries)
    }
    if(date) {
      const dates = filter(monthes, (item) =>
        convertToArray(date).includes(`${item.from}`),
      )
      setSelectedMonthes(dates)
    }

    if(!store.get('special-deals-dropdown')) {
      typeRef.current.focus()
      store.session('special-deals-dropdown', true)
    } else if(!date) {
      timeRef.current.focus()
    } else if(!country) {
      countryRef.current.focus()
    }
  }, [])

  return (
    <div className='deals-filters'>
      <Select
        onChange={(...args) => {
          setDealsType(...args)
        }}
        value={type}
        options={OPERATOR_TYPES}
        getOptionLabel={(option) => option.title}
        getOptionValue={(option) => option.id}
        styles={getAutosuggestStyle('60px')}
        menuIsOpen={isMenuOpen.type}
        placeholder={
          <FormattedMessage
            id='resort_or_la'
            defaultMessage='Resort or Liveaboard?'
          />
        }
        onFocus={() => openMenu('type')}
        onInputChange={(_, { action }) => onInputChange('type', action)}
        isSearchable={false}
        className='select-container'
        classNamePrefix='select-container'
        ref={typeRef}
      />
      <div className='deals-filters__filter'>
        <Select
          onChange={(...args) => {
            setSelectedMonthes(...args)
          }}
          value={selectedMonthes}
          options={monthes}
          getOptionValue={(option) => option.from}
          styles={getAutosuggestStyle('60px')}
          placeholder={
            <FormattedMessage
              id='time_of_travel'
              defaultMessage='Time of travel?'
            />
          }
          controlShouldRenderValue={false}
          isMulti
          menuIsOpen={isMenuOpen.time}
          onFocus={() => openMenu('time')}
          onInputChange={(_, { action }) => onInputChange('time', action)}
          isSearchable={false}
          isClearable
          className='select-container'
          classNamePrefix='select-container'
          closeMenuOnSelect={false}
          ref={timeRef}
        />
        <SelectedOptions
          options={selectedMonthes}
          labelKey='label'
          idKey='from'
          onClick={removeSelectedMonth}
        />
      </div>
      <div>
        <Select
          onChange={(...args) => {
            setSelectedCountries(...args)
          }}
          value={selectedCountries}
          options={window.info.activeCountryList}
          getOptionLabel={(option) => option.title}
          getOptionValue={(option) => option.id}
          styles={getAutosuggestStyle('60px')}
          placeholder={
            <FormattedMessage id='country?' defaultMessage='Country?' />
          }
          isMulti
          controlShouldRenderValue={false}
          isSearchable
          isClearable
          className='select-container'
          classNamePrefix='select-container'
          closeMenuOnSelect={false}
          menuIsOpen={isMenuOpen.country}
          onFocus={() => openMenu('country')}
          ref={countryRef}
          onInputChange={(_, { action }) => onInputChange('country', action)}
        />
        <SelectedOptions
          options={selectedCountries}
          idKey='id'
          labelKey='title'
          onClick={removeSelectedCountry}
        />
      </div>
    </div>
  )
}

DealsFilters.propTypes = {
  type: PropTypes.object,
  monthes: PropTypes.array,
  selectedMonthes: PropTypes.array,
  setSelectedMonthes: PropTypes.func,
  setDealsType: PropTypes.func,
  setSelectedCountries: PropTypes.func,
  selectedCountries: PropTypes.array,
  removeSelectedMonth: PropTypes.func,
  removeSelectedCountry: PropTypes.func,
}
